import React from 'react'
import { Card, Typography, Divider, Grid, Skeleton, Breadcrumbs } from '@mui/material'
import { Box } from '@mui/system'
import PolicyFormModal from './PolicyFormModal'
import AddIcon from '@mui/icons-material/Add'
import AdxButton from 'components/custom/AdxButton'

const PolicySetting = ({ policyData, loading, approvalRoutes, reimbursementAdmins }) => {
  const formatAmount = (value) => {
    if (value === null || value === '' || Number.isNaN(Number(value))) {
      return null
    }

    return `RM ${parseFloat(value).toFixed(2)}`
  }

  const priceLimitConstructor = (min, max, index, total) => {
    const from = formatAmount(min)
    const to = formatAmount(max)

    if (total === 1 && Number(min) === 0 && to === null) {
      return 'All claim amounts'
    }

    if (to === null) {
      return `${from || 'RM 0.00'} and above`
    }

    if ((min === null || min === '' || Number(min) === 0 || Number.isNaN(Number(min))) && index === 0) {
      return `Below ${to}`
    }

    return `${from || 'RM 0.00'} - ${to}`
  }

  const approvalStepCountText = (roles = []) => {
    const count = roles.length

    return `${count} approval ${count === 1 ? 'step' : 'steps'} + reimbursement`
  }

  return (
    <Card
      variant="outlined"
      sx={{
        boxSizing: 'border-box',
        borderRadius: '4.5px',
      }}
    >
      {loading && (
        <>
          <Grid
            justifyContent={'space-between'}
            p={2}
            container
            height={90}
            display="flex"
            alignItems="center"
          >
            <Skeleton variant="text" width={200} />
            <Skeleton variant="text" width={80} />
          </Grid>
          <Divider variant="full" />
        </>
      )}
      {!loading && policyData.length !== 0 ? (
        <>
          {policyData?.map((item, index) => (
            <React.Fragment key={index}>
              <Grid
                p={2}
                paddingRight={3}
                container
                minHeight={90}
                display="flex"
                justifyContent="flex-start"
                alignItems={{ xs: 'start', lg: 'center' }}
                flexDirection={{ xs: 'column', lg: 'row' }}
                rowGap={1}
                columnGap={5}
              >
                <Box display="flex" flexDirection={{ xs: 'column', lg: 'row' }}>
                  <Grid item>
                    <Typography
                      sx={{ fontWeight: 'medium', minWidth: 95 }}
                      variant="subtitle1"
                      color="light-gray-text.main"
                      mr={1}
                    >
                      Claim Rule {index + 1}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      variant="body1"
                      color="dark-text.main"
                      sx={{
                        fontWeight: 'bold',
                        minWidth: { xs: null, lg: 180 },
                      }}
                    >
                      {priceLimitConstructor(item.amount_from, item.amount_to, index, policyData.length)}
                    </Typography>
                  </Grid>
                </Box>
                <Grid item mt={{ xs: 1, lg: 0 }} minWidth={{ xs: null, lg: 500 }}>
                  <Box>
                    <Typography variant="body1" color="dark-text.main">
                      {item.approval_route}
                    </Typography>
                    <Breadcrumbs color="light-gray-text.main" separator=">" sx={{ fontSize: 14 }}>
                      {item.role.map((role, index) => (
                        <Typography variant="body2" key={index}>
                          {role.name}
                        </Typography>
                      ))}
                    </Breadcrumbs>
                    <Typography variant="body2" color="light-gray-text.main" mt={0.5}>
                      {approvalStepCountText(item.role)}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              <Divider variant="full" />
            </React.Fragment>
          ))}
          <PolicyFormModal
            policyData={policyData}
            approvalRoutes={approvalRoutes}
            reimbursementAdmins={reimbursementAdmins}
          >
            <Box p={0.5}>
              <AdxButton
                variant={'ghost'}
                disabled={loading}
                sx={{
                  pl: 2,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  width: '100%',
                }}
              >
                <Typography
                  display="flex"
                  alignItems="center"
                  columnGap={0.55}
                  color={loading ? 'gray-inactive-button.main' : 'alternate.main'}
                  sx={{ fontWeight: 'medium' }}
                  variant="subtitle1"
                >
                  Set claim approval rules
                </Typography>
              </AdxButton>
            </Box>
          </PolicyFormModal>
        </>
      ) : (
        <PolicyFormModal
          policyData={policyData}
          approvalRoutes={approvalRoutes}
          reimbursementAdmins={reimbursementAdmins}
        >
          <AdxButton
            variant={'ghost'}
            fullWidth
            disabled={loading}
            sx={{
              height: 180,
            }}
          >
            <Typography
              display="flex"
              alignItems="center"
              justifyContent="center"
              columnGap={0.55}
              color={loading ? 'gray-inactive-button.main' : 'alternate.main'}
              sx={{ padding: 2, fontWeight: 'medium' }}
              variant="subtitle1"
            >
              <AddIcon sx={{ fontSize: 20 }} />
              Create claim approval rules
            </Typography>
          </AdxButton>
        </PolicyFormModal>
      )}
    </Card>
  )
}

export default PolicySetting
